type Scope = { region?: string | null; cropSeason?: string | null };

export const resolveStorageKey = (pathname: string, scope: Scope): string => {
  const region = scope.region ?? '_';
  const season = scope.cropSeason ?? '_';
  return `${pathname}::region=${region}::season=${season}`;
};
